<template>
  <div class="page">
    <!-- FORMULAIRE (caché à l'impression) -->
    <section class="no-print form">
      <h2>Générer un bon de livraison</h2>

      <div class="grid">
        <div class="field">
          <label>Date</label>
          <input type="date" v-model="form.dateIso" />
        </div>

        <div class="field">
          <label>Expéditeur - Nom</label>
          <input v-model.trim="form.expediteurNom" placeholder="ALIF" />
        </div>

        <div class="field">
          <label>Expéditeur - Adresse ligne 1</label>
          <input v-model.trim="form.expediteurAddr1" placeholder="12 RUE PARIS" />
        </div>

        <div class="field">
          <label>Expéditeur - Adresse ligne 2</label>
          <input v-model.trim="form.expediteurAddr2" placeholder="60420 TRICOT" />
        </div>

        <div class="field">
          <label>Destinataire - Nom</label>
          <input v-model.trim="form.destNom" placeholder="CLIENT-ANJARY" />
        </div>

        <div class="field">
          <label>Destinataire - Adresse ligne 1</label>
          <input v-model.trim="form.destAddr1" placeholder="Adresse" />
        </div>

        <div class="field">
          <label>Destinataire - Adresse ligne 2</label>
          <input v-model.trim="form.destAddr2" placeholder="Code postal Ville" />
        </div>

        <div class="field">
          <label>Total pallet</label>
          <input type="number" min="0" v-model.number="form.totalPallet" />
        </div>

        <div class="field">
          <label>Total colis</label>
          <input type="number" min="0" v-model.number="form.totalColis" />
        </div>
      </div>

      <div class="actions">
        <button type="button" @click="printDeliveryNote">
          Imprimer / Enregistrer en PDF
        </button>
      </div>

      <p class="hint">
        Dans la fenêtre d’impression, choisis “Enregistrer en PDF”.
      </p>
    </section>

    <!-- BON (visible uniquement à l'impression) -->
    <section class="print-only">
      <div class="sheet">
        <div class="top-left">
          <div class="big">DATE {{ formattedDate }}</div>
          <div class="big">BON DE LIVRAISON</div>
        </div>

        <div class="center-block text-decoration-underline">
          <div class="u mid">EXPEDITEUR</div>
          <div class="u name">{{ form.expediteurNom }}</div>
          <div class="u line">{{ form.expediteurAddr1 }}</div>
          <div class="u line">{{ form.expediteurAddr2 }}</div>
        </div>

        <div class="center-block dest text-decoration-underline">
          <div class="u title">DESTINATAIRE</div>
          <div class="u dest-name">CLIENT-{{ form.destNom }}</div>
          <div class="u line">Adress-{{ form.destAddr1 }}</div>
          <div class="u line">{{ form.destAddr2 }}</div>
        </div>

        <div class="bottom text-decoration-underline">
          <div class="u mid">LIVRAISON PAR NOUS MEME</div>

          <div class="u mid mt">TOTALPALLET-{{ form.totalPallet }}</div>
          <div class="u mid">{{ form.totalColis }}COLIS</div>
        </div>
      </div>
    </section>

    <!-- Aperçu écran optionnel (facultatif) -->
    <section class="no-print preview">
      <h3>Aperçu (écran)</h3>
      <div class="sheet screen-preview">
        <div class="top-left">
          <div class="big">DATE {{ formattedDate }}</div>
          <div class="big">BON DE LIVRAISON</div>
        </div>

        <div class="center-block text-decoration-underline">
          <div class="u mid">EXPEDITEUR</div>
          <div class="u name">{{ form.expediteurNom }}</div>
          <div class="u line">{{ form.expediteurAddr1 }}</div>
          <div class="u line">{{ form.expediteurAddr2 }}</div>
        </div>

        <div class="center-block dest text-decoration-underline">
          <div class="u title">DESTINATAIRE</div>
          <div class="u dest-name">CLIENT-{{ form.destNom }}</div>
          <div class="u line">Adress-{{ form.destAddr1 }}</div>
          <div class="u line">{{ form.destAddr2 }}</div>
        </div>

        <div class="bottom text-decoration-underline">
          <div class="u mid">LIVRAISON PAR NOUS MEME</div>
          <div class="u mid mt">TOTALPALLET-{{ form.totalPallet }}</div>
          <div class="u mid">{{ form.totalColis }}COLIS</div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import axios from 'axios'
function pad2(n) {
  return String(n).padStart(2, "0");
}

function todayIso() {
  const d = new Date();
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

function formatFrFromIso(iso) {
  // YYYY-MM-DD -> DD/MM/YYYY
  if (!iso || iso.length !== 10) return "";
  const parts = iso.split("-");
  if (parts.length !== 3) return "";
  const y = parts[0];
  const m = parts[1];
  const d = parts[2];
  return `${d}/${m}/${y}`;
}

function defaults() {
  return {
    dateIso: todayIso(),
    expediteurNom: "ALIF",
    expediteurAddr1: "12 RUE PARIS",
    expediteurAddr2: "60420 TRICOT",
    destNom: "",
    destAddr1: "",
    destAddr2: "",
    totalPallet: 1,
    totalColis: 12,
  };
}

export default {
  name: "BonDeCommande",
  props: ['clientId'],
  data() {
    return {
      form: defaults(),
      clientDetails: {},
    };
  },
  computed: {
    ...mapGetters(['apiURL']),
    formattedDate() {
      return formatFrFromIso(this.form.dateIso);
    },
  },
  methods: {
    ...mapMutations(['addMessageAxios']),
    printDeliveryNote() {
      // Ici tu peux ajouter une validation si besoin
      window.print();
    },
    resetDefaults() {
      this.form = defaults();
    },

    async fetchClientDetails() {
      try {
        let clientRes = await axios.get(`${this.apiURL}/clients/clients/${this.clientId}`)
        console.log(clientRes.data)
        this.clientDetails = clientRes.data
        this.form.destNom = this.clientDetails.name || ''
        this.form.destAddr1 = this.clientDetails.address || ''
        this.form.destAddr2 = [this.clientDetails.postal_code, this.clientDetails.city].filter(Boolean).join(' ')
      } catch(err) {
        console.log(err)
        this.addMessageAxios({message: err.response.data, isError: true})
      }
    },
  },
  mounted() {
    this.fetchClientDetails()
  }
};
</script>

<style scoped>
.page {
  padding: 16px;
  font-family: Arial, sans-serif;
}

/* Form */
.form {
  max-width: 900px;
  margin: 0 auto 24px auto;
}
.grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 16px;
}
.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.field label {
  font-size: 14px;
}
.field input {
  padding: 8px 10px;
  font-size: 14px;
}
.actions {
  display: flex;
  gap: 10px;
  margin-top: 14px;
}
button {
  padding: 10px 12px;
  cursor: pointer;
}
button.secondary {
  opacity: 0.8;
}
.hint {
  margin-top: 10px;
  font-size: 13px;
  opacity: 0.8;
}

/* Feuille A4 */
.sheet {
  width: 210mm;
  min-height: 297mm;
  margin: 0 auto;
  padding: 18mm 16mm;
  box-sizing: border-box;
  background: #fff;
  color: #000;
}

.top-left .big {
  font-size: 28px;
  line-height: 1.15;
}

.center-block {
  margin-top: 26mm;
  text-align: center;
}
.center-block.dest {
  margin-top: 22mm;
}
.bottom {
  margin-top: 28mm;
  text-align: center;
}

.uz {
  display: inline-block;
  border-bottom: 2px solid #000;
  padding-bottom: 2px;
}

.mid {
  font-size: 26px;
}
.name {
  font-size: 26px;
  margin-top: 8px;
}
.title {
  font-size: 26px;
}
.dest-name {
  font-size: 32px;
  margin-top: 10px;
}
.line {
  font-size: 20px;
  margin-top: 8px;
}
.mt {
  margin-top: 18mm;
}

/* Aperçu écran (optionnel) */
.preview {
  max-width: 900px;
  margin: 0 auto;
}
.screen-preview {
  border: 1px solid #ddd;
  transform: scale(0.85);
  transform-origin: top center;
  margin-top: 10px;
}

/* PRINT RULES */
.print-only {
  display: none;
}

@media print {
  .no-print {
    display: none !important;
  }
  .print-only {
    display: block !important;
  }

  .page {
    padding: 0;
  }
  .sheet {
    margin: 0;
  }
}

/* Marges papier */
@page {
  size: A4;
  margin: 12mm;
}
</style>
